module.exports = __webpack_public_path__ + "static/media/1234.0bf2cfe5.png";